import { useStaticQuery, graphql } from 'gatsby'

export function useDataVideosByEn() {
    const data = useStaticQuery(graphql`
        {
            videosEn: allDatoCmsRenshinTeamVideo(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    id
                    title
                    text
                    videoUrl
                    sorting
                    poster {
                        url
                    }
                }
            }
        }
    `)

    return data.videosEn.nodes
}
